export const CloseButton = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="flex justify-end">
      <button
        className="text-3xl"
        onClick={() => {
          onClose()
        }}
      >
        X
      </button>
    </div>
  )
}
